export const HandIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="10 7 15 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 13H12V14H9V13Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19 13H22V14H19V13Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3536 8.64648L13.3536 10.6465L12.6465 11.3536L10.6465 9.35359L11.3536 8.64648Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.3536 9.35359L18.3536 11.3536L17.6465 10.6465L19.6465 8.64648L20.3536 9.35359Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 7V10H15V7H16Z"
				fill="white"
			/>
			<path
				d="M14.9996 13.499C14.9996 13.2229 15.2234 12.999 15.4996 12.999C15.7757 12.999 15.9996 13.2229 15.9996 13.499V16.0001C15.9996 16.238 16.1672 16.443 16.4005 16.4901L19.2958 17.0754C20.134 17.2449 20.6612 18.0797 20.4538 18.9094L19.6222 22.2373C19.575 22.426 19.4226 22.5703 19.2316 22.607L17.2309 22.992C17.0874 23.0197 16.9218 22.9837 16.7476 22.8662C16.5713 22.7474 16.415 22.562 16.3177 22.3577C16.0672 21.8321 15.6326 21.2504 14.8896 20.8503L11.0322 18.5608C11.237 18.0979 11.7822 17.8751 12.2595 18.0804L14.3019 18.9593C14.4564 19.0258 14.634 19.0102 14.7745 18.9177C14.915 18.8252 14.9996 18.6683 14.9996 18.5001V13.499ZM15.4996 11.999C14.6711 11.999 13.9996 12.6706 13.9996 13.499V17.7406L12.6547 17.1619C11.5979 16.7071 10.3799 17.2682 10.0387 18.367C9.92083 18.7468 10.0789 19.1578 10.4208 19.3608L14.3885 21.7158C14.3949 21.7196 14.4015 21.7233 14.4081 21.7268C14.9307 22.006 15.2346 22.4093 15.4149 22.7878C15.5832 23.1411 15.8532 23.4692 16.1885 23.6953C16.5258 23.9228 16.9569 24.0631 17.4199 23.974L19.4205 23.589C19.9937 23.4787 20.4508 23.046 20.5923 22.4797L21.424 19.1518C21.7695 17.7691 20.891 16.3777 19.4939 16.0953L16.9996 15.591V13.499C16.9996 12.6706 16.328 11.999 15.4996 11.999Z"
				fill="white"
			/>
		</svg>
	);
};
